<template>
  <floor
    title="普惠直播台"
    sub-title="种草拔草 通通都有"
    sub-title-color="#2ea7e0"
    @show-more="gotoBsyqMiniProgram('/live-playback/index')"
  >
    <div class="live-list">
      <van-image
        v-for="i in columns"
        :key="i"
        class="live-item"
        lazy-load
        width="29.333vw"
        height="29.333vw"
        :src="lives[i - 1] ? lives[i - 1].coverImg : ''"
        :alt="lives[i - 1] ? lives[i - 1].name : ''"
        @click="gotoLive(lives[i - 1] ? lives[i - 1].roomId : '')"
      >
        <div slot="error" class="live-empty">
          <img src="@/assets/images/puhui/sy-w4.png" />
          <div class="live-empty--text">主播都去休息啦！</div>
        </div>
      </van-image>
    </div>
  </floor>
</template>

<script>
import Floor from './components/Floor'
import { getLiveRooms } from '@/api/live'
import { BSYQ_FRONTEND_URL } from '@/config/domainnameconstant'

export default {
  name: 'LiveFloor',
  components: {
    Floor
  },
  data() {
    return {
      columns: 3,
      lives: []
    }
  },
  mounted() {
    this.loadLives()
  },
  methods: {
    /**
     * 加载直播间
     */
    loadLives() {
      getLiveRooms({
        SkipCount: 0,
        MaxResultCount: 4,
        LiveType: 0,
        LiveStatuses: 101
      }).then(res => {
        this.lives = res.data.result.items
      })
    },

    /**
     * 跳转到播商友圈小程序
     */
    gotoBsyqMiniProgram(path) {
      const url = `${BSYQ_FRONTEND_URL}${path}`
      const link = `/pages/web?needauth=true&url=${encodeURIComponent(url)}`

      this.$callApp('Android', 'GoWXMiniProgramMethod', link)
      this.$callApp('iOS', 'GoWXMiniProgramMethod', link)
    },

    /**
     * 跳转到直播间
     */
    gotoLive(roomId) {
      if (roomId) {
        this.$callApp('Android', 'GoWechatRoomMethod', roomId)
        this.$callApp('iOS', 'GoWechatRoomMethod', roomId)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.live {
  &-list {
    display: flex;
    justify-content: space-between;

    &-item {
      border: 1px solid #e4e5e5;
      border-radius: 2px;
      overflow: hidden;
    }
  }

  &-empty {
    color: #b5b5b6;
    font-size: 12px;
    text-align: center;

    img {
      width: 30px;
    }

    &--text {
      margin-top: 10px;
    }
  }
}
</style>
